import { UnitApplicationApplicationStatus as E, RenewalApplicationStatus as C } from "@propify-tenant-client/services";
const N = "280px", n = "leasing@nationalhomerentals.com", o = "866-833-0449", D = {
  [E.PENDING]: "#7B61FF",
  [E.ACCEPTED]: "#00C62B",
  [E.REJECTED]: "#E00000",
  [E.CANCELLED]: "#E00000"
}, A = {
  [E.PENDING]: "INVITE SENT",
  [E.ACCEPTED]: "INVITE ACCEPTED",
  [E.REJECTED]: "INVITE DECLINED",
  [E.CANCELLED]: "INVITE CANCELLED"
}, T = {
  [C.PENDING]: "#7B61FF",
  [C.ACCEPTED]: "#00C62B",
  [C.REJECTED]: "#E00000",
  [C.CANCELLED]: "#E00000"
}, a = {
  [C.PENDING]: "INVITE SENT",
  [C.ACCEPTED]: "INVITE ACCEPTED",
  [C.REJECTED]: "INVITE DECLINED",
  [C.CANCELLED]: "INVITE CANCELLED"
};
export {
  n as CONTACT_EMAIL,
  o as CONTACT_PHONE,
  N as DRAWER_WIDTH,
  T as renewalApplicationColorByStatus,
  a as renewalApplicationLabelByStatus,
  D as unitApplicationApplicationColorByStatus,
  A as unitApplicationApplicationLabelByStatus
};
//# sourceMappingURL=constants.js.map
